
import React, { useState } from 'react';
import './Verify.css';

const Verify = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [step, setStep] = useState(1); // 1: phone input, 2: OTP verification
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [platformUrl, setPlatformUrl] = useState('');
  const [platformName, setPlatformName] = useState('');
  const [showPlatformSelection, setShowPlatformSelection] = useState(false);

  const faqItems = [
    {
      question: "Who gets access after verification?",
      answer: "Verified members get exclusive access to our Inner Circle community, live market updates, trading strategies, and premium content designed for serious traders."
    },
    {
      question: "How to join the Crypto Club?",
      answer: "After phone verification, you'll receive information about joining our exclusive Crypto Club where we share advanced cryptocurrency trading strategies and market insights."
    },
    {
      question: "Which platform is best in India for crypto trading?",
      answer: "We provide guidance on the best crypto trading platforms based on your experience level, trading volume, and specific needs. Popular options include WazirX, CoinDCX, and Binance."
    },
    {
      question: "How to get added to the H-Level Group?",
      answer: "H-Level Group is our premium tier for advanced traders. Complete verification, demonstrate consistent trading performance, and you'll be invited to join this exclusive community."
    },
    {
      question: "I completed all steps but didn't get access — what now?",
      answer: "If you're having access issues, please contact our support team at harshcares@gmail.com or call +91 8188988788. We'll resolve any technical problems immediately."
    }
  ];

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (!phoneNumber || phoneNumber.length !== 10) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Call the verify-client API
      const response = await fetch(`https://verify.harshbhagat.com/admin/api/verify-client?phone=${phoneNumber}`, {
        headers: {
          'Authorization': 'Bearer nj9OtP0IehK6ngHbxuKL3jgJ7iMcgdMZiF82hccqkTRxDqrHiVfXkFmyrzcPkX1kPD671E0RY3pjzIB3',
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();

      if (data.status === 'success') {
        if (data.visit_count >= 2) {
          // Show limit exceeded message
          setError(
            <span>
              You have exceeded the limit for getting the joining link, if still not added,{' '}
              <a href="https://wa.link/hqgao8" target="_blank" rel="noopener noreferrer" style={{ color: '#00d4ff', textDecoration: 'underline' }}>
                chat with our team or Click here
              </a>
            </span>
          );
          setIsLoading(false);
          return;
        }

        if (data.message === "user_not_found") {
          setError("Please Enter a Registerd Mobile Number");
          setIsLoading(false);
          return
        }

        // If visit count is less than 2, check platform_id
        if (data.platform_id === 3) {
          // Show platform selection options
          setShowPlatformSelection(true);
        } else {
          // Get platform URL directly for other platform_ids
          await getPlatformUrl(data.platform_id);
        }
      } else {
        setError('Verification failed. Please check your phone number and try again.');
      }
    } catch (error) {
      console.error('API Error:', error);
      setError('Network error. Please check your connection and try again.');
    }

    setIsLoading(false);
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus next input
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const otpString = otp.join('');

    if (otpString.length !== 6) {
      setError('Please enter the complete 6-digit OTP');
      return;
    }

    setIsLoading(true);
    setError('');

    // Simulate verification
    setTimeout(() => {
      setIsLoading(false);
      alert('Verification successful! Welcome to the Inner Circle.');
    }, 2000);
  };

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const resendOTP = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      alert('New OTP sent to your mobile number');
    }, 1000);
  };

  const closeModal = () => {
    setShowModal(false);
    setPlatformUrl('');
    setPlatformName('');
  };

  const getPlatformUrl = async (platformId) => {
    try {
      const platformResponse = await fetch(`https://verify.harshbhagat.com/admin/api/get-platform-url?platform_id=${platformId}`, {
        headers: {
          'Authorization': 'Bearer nj9OtP0IehK6ngHbxuKL3jgJ7iMcgdMZiF82hccqkTRxDqrHiVfXkFmyrzcPkX1kPD671E0RY3pjzIB3',
          'Content-Type': 'application/json'
        }
      });
      const platformData = await platformResponse.json();

      console.log('Platform Data:', platformData);

      if (platformData.status === 'success') {
        setPlatformUrl(platformData.url);
        setPlatformName(platformData.platform);
        setShowModal(true);
      } else {
        setError('Failed to get platform URL. Please try again.');
      }
    } catch (error) {
      console.error('Platform API Error:', error);
      setError('Network error. Please check your connection and try again.');
    }
  };

  const handlePlatformSelection = async (platformId) => {
    setShowPlatformSelection(false);
    setIsLoading(true);
    await getPlatformUrl(platformId);
    setIsLoading(false);
  };

  return (
    <div className="verify-page">
      {/* Background with gradient */}
      <div className="verify-background">

        {/* Main heading */}
        <div className="main-heading">
          <h1 className="verify-title">VERIFY TO JOIN</h1>
        </div>
        <div className="decorative-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>

        {/* Main Verification Section */}
        <section className="verification-section">
          <div className="verification-container">
            {showPlatformSelection ? (
              <>
                <div className="verify-header">
                  {/* <h1 className="verify-title">SELECT PLATFORM</h1> */}
                  <p className="verify-subtitle">
                    Choose your preferred platform to continue your journey
                  </p>
                </div>

                <div className="platform-selection">
                  <button
                    className="platform-btn"
                    onClick={() => handlePlatformSelection(1)}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="loading-spinner"></span>
                    ) : (
                      'H Level Group'
                    )}
                  </button>

                  <button
                    className="platform-btn"
                    onClick={() => handlePlatformSelection(2)}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="loading-spinner"></span>
                    ) : (
                      'Crypto Club'
                    )}
                  </button>
                </div>
              </>
            ) : step === 1 ? (
              <>
                <div className="verify-header">
                  <p className="verify-subtitle">
                    Once verified, you'll be redirected to the next step in your journey,
                    where you can unlock more valuable insights and opportunities.
                  </p>
                </div>

                <form onSubmit={handlePhoneSubmit} className="verification-form">
                  <div className="form-section">
                    <label htmlFor="phone" className="form-label">Register Mobile Number</label>
                    <div className="phone-input-container">
                      <input
                        type="tel"
                        id="phone"
                        className="phone-input"
                        placeholder="XXXXXXXXXX"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                        maxLength="10"
                        required
                      />
                    </div>
                  </div>

                  {error && <div className="error-message">{error}</div>}

                  <button
                    type="submit"
                    className="continue-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="loading-spinner"></span>
                    ) : (
                      'Continue →'
                    )}
                  </button>

                  <p className="register-link">
                    User Not Registered Yet? <a target='_blank' href="https://wa.link/cwvcl6">Click here to Register</a>
                  </p>
                </form>
              </>
            ) : (
              <>
                <div className="verify-header">
                  <h1 className="verify-title">ENTER OTP</h1>
                  <p className="verify-subtitle">
                    We've sent a 6-digit verification code to +91 {phoneNumber}
                  </p>
                </div>

                <form onSubmit={handleOtpSubmit} className="otp-form">
                  <div className="otp-inputs">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        id={`otp-${index}`}
                        className="otp-input"
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        maxLength="1"
                        required
                      />
                    ))}
                  </div>

                  {error && <div className="error-message">{error}</div>}

                  <button
                    type="submit"
                    className="continue-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="loading-spinner"></span>
                    ) : (
                      'Verify & Continue'
                    )}
                  </button>

                  <div className="otp-actions">
                    <button
                      type="button"
                      className="resend-btn"
                      onClick={resendOTP}
                      disabled={isLoading}
                    >
                      Resend OTP
                    </button>
                    <button
                      type="button"
                      className="change-number-btn"
                      onClick={() => setStep(1)}
                    >
                      Change Number
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </section>
      </div>

      {/* FAQ Section */}
      < section className="faq-section" >
        <div className="container">
          <div className="faq-content">

            <div className="faq-list">
              <h2 className="faq-title  animate-on-scroll">People also ask us</h2>
              {faqItems.map((item, index) => (
                <div key={index} className="faq-item animate-on-scroll">
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={activeFAQ === index}
                  >
                    <span>{item.question}</span>
                    <span className={`faq-arrow ${activeFAQ === index ? 'active' : ''}`}>
                      <img src='./assets/icons/down-arrow.png' alt='down-arrow' />
                    </span>
                  </button>
                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section >

      {/* Modal for Platform URL */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Welcome to {platformName}</h3>
              <button className="modal-close" onClick={closeModal}>&times;</button>
            </div>
            <div className="modal-body">
              <iframe
                src={platformUrl}
                title={platformName}
                width="100%"
                height="400px"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Verify;